/**
 * Image-size helpers.
 *
 * Wix-hosted images use the URL pattern:
 *   https://static.wixstatic.com/media/{hash}/v1/{fit|fill}/w_{W},h_{H},al_c,q_{Q}/file.jpg
 * They support on-the-fly resizing — so for thumbnails we can rewrite the
 * width/height to ~800×600 instead of downloading the 1800×3600 original.
 * This cuts ArticleCard image weight by roughly 75%.
 *
 * Non-Wix images (uploaded to our object storage, etc.) are returned as-is.
 */

const SIZE_PRESETS = {
  thumb: { w: 400, h: 300 },    // dense lists / row thumbs
  card: { w: 800, h: 600 },     // standard article-card cover
  hero: { w: 1600, h: 1000 },   // top-of-page hero
  portrait: { w: 600, h: 750 }, // guest tiles, 4:5
};

export function resizeImage(url, preset = "card") {
  if (!url || typeof url !== "string") return url;
  // Only Wix CDN supports the path-based resize trick we use here.
  if (!url.includes("static.wixstatic.com/media/")) return url;
  const { w, h } = SIZE_PRESETS[preset] || SIZE_PRESETS.card;
  // Replace the WxH portion. We also lower quality to 80 for thumbs (still
  // visually indistinguishable on a 4/3 card) to save another ~15% per image.
  return url.replace(
    /\/v1\/(fit|fill)\/w_\d+,h_\d+,al_c,q_\d+/i,
    `/v1/fit/w_${w},h_${h},al_c,q_80`,
  );
}
